module.exports = __webpack_public_path__ + "img/lose.03d89aa6.png";